import { OrganizationPublicId } from "../service/server/Types";
import { NetworkRequestState } from "../models";
import { RefreshFn, useDataRequest } from "./api";
import { Api } from "../service/Api";
import { AuditLogEntryDto } from "../service/server/dto/AuditLogEntryDto";

export const useAuditLogs = (
  organizationId: OrganizationPublicId,
): [AuditLogEntryDto[], NetworkRequestState, RefreshFn] => {
  const {
    result: auditLogs,
    request,
    refresh,
  } = useDataRequest({
    queryKey: ["auditLogs", organizationId],
    staleTime: 5 * 1000, // 5 seconds
    cacheTime: 5 * 1000,
    api: () => Api.auditLogs.getAuditLogs(organizationId),
    messages: {
      defaultError: "Failed to load audit logs.",
    },
    dependencies: [organizationId],
  });

  return [auditLogs, request, refresh];
};
